import React from 'react';

type Props = {
  zoom: number;
  minZoom: number;
  maxZoom: number;
  onZoomOut: () => void;
  onZoomReset: () => void;
  onZoomIn: () => void;
};

const buttonStyle: React.CSSProperties = {
  minWidth: 36,
  height: 36,
  borderRadius: 8,
  border: '1px solid var(--hbr-color-neutral-border-weak)',
  background: 'var(--hbr-color-neutral-bg)',
  color: 'var(--hbr-color-neutral-text)',
  cursor: 'pointer',
  font: 'inherit',
  fontWeight: 700,
};

const JourneyMapViewportControls: React.FC<Props> = ({
                                                       zoom,
                                                       minZoom,
                                                       maxZoom,
                                                       onZoomOut,
                                                       onZoomReset,
                                                       onZoomIn,
                                                     }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
        marginBottom: '12px',
      }}
    >
      <button type="button" onClick={onZoomOut} disabled={zoom <= minZoom} style={buttonStyle}>
        −
      </button>

      <button type="button" onClick={onZoomReset} style={buttonStyle}>
        {Math.round(zoom * 100)}%
      </button>

      <button type="button" onClick={onZoomIn} disabled={zoom >= maxZoom} style={buttonStyle}>
        +
      </button>
    </div>
  );
};

export default JourneyMapViewportControls;